import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { EmailIconColor, EmailsIcon } from "../../../assets/images";
import { CalenderIcon } from "../../Icon";
import { SelectOptionType } from "../../../redux/scheduling/schedulingTypes";
import moment from "moment";

type AppProps = {
  emailReportStartDate: any;
  emailReportEndDate: any;
  header: string;
  type?: string;
  showDropdown: boolean;
  setEmailDepartment?: React.Dispatch<React.SetStateAction<SelectOptionType>>;
  setShowDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  handleEmailReportStartDate?: (date: any) => void;
  handleEmailReportEndDate?: (date: any) => void;
  handleEmailClientWiseTimesheetReportData?: () => void;
  handleResetEmailEndDate?: () => void;
  setUsersEmailDepartmentText?: React.Dispatch<React.SetStateAction<string>>;
  userType?: string;
};

const EmailTimeSheetReportPopup = ({
  type,
  header,
  showDropdown,
  setShowDropdown,
  setEmailDepartment,
  emailReportEndDate,
  emailReportStartDate,
  handleEmailReportEndDate,
  handleEmailReportStartDate,
  handleResetEmailEndDate,
  handleEmailClientWiseTimesheetReportData
}: AppProps) => {
  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    if (!emailReportStartDate) {
      handleResetEmailEndDate && handleResetEmailEndDate();
    }
  }, [emailReportStartDate]);

  return (
    <ButtonDropdown
      isOpen={showDropdown}
      toggle={toggleShowDropdown}
      className="download-report-btn"
      style={
        showDropdown
          ? {
              color: "#dd4433",
              backgroundColor: "#fff6f5",
            }
          : {}
      }
    >
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-download-invoice">{header}</Tooltip>}
      >
        <DropdownToggle
          caret
          outline
          style={
            showDropdown
              ? {
                  color: "#dd4433",
                  backgroundColor: "#fff6f5",
                  marginTop:"3px"
                }
              : { border: "1px solid#bfcbe1" ,  marginTop:"3px"}
          }
        >
          <img
            src={showDropdown ? EmailIconColor : EmailsIcon}
            alt="Email Timesheet Report"
            width="20px"
            height="20px"
          />
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right className="download-dropdown">
        <div className="p-3">
          <h4 className="mb-4">{header}</h4>
          <div className="row">
            <div className="col-md-6">
              <div>Start Date </div>
              <Row>
                <Col md="12" className="download-report-picker">
                  <Label className="m-0 p-0">
                    <span className="calender-icon">
                      <CalenderIcon />
                    </span>
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={emailReportStartDate}
                      onChange={(date: any) =>
                        handleEmailReportStartDate?.(date)
                      }
                      selectsStart
                      showMonthDropdown
                      showYearDropdown
                      startDate={emailReportStartDate}
                      endDate={emailReportEndDate}
                      className="form-control"
                    //   minDate={"2023-12-01" ? new Date("2023-12-01") : null}
                    />
                  </Label>
                </Col>
              </Row>
            </div>
            <div className="col-md-6">
              <div>End Date </div>
              <Row>
                <Col md="12" className="download-report-picker">
                  <Label className="m-0 p-0">
                    <span className="calender-icon">
                      <CalenderIcon />
                    </span>
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={emailReportEndDate}
                      onChange={(date: any) => handleEmailReportEndDate?.(date)}
                      selectsStart
                      showMonthDropdown
                      showYearDropdown
                      minDate={emailReportStartDate}
                      maxDate={moment(emailReportStartDate).add(40,"days")?.toDate() }
                      startDate={emailReportStartDate}
                      endDate={emailReportEndDate}
                      className="form-control"
                      disabled={!emailReportStartDate}
                    />
                  </Label>
                </Col>
              </Row>
            </div>

          

            <div className="col-md-12 mt-3 text-right">
              <button
                className="btn btn-outline-secondary mr-3"
                onClick={() => {
                  toggleShowDropdown();
                  handleEmailReportStartDate?.("");
                  handleEmailReportEndDate?.("");
                  setEmailDepartment &&
                    setEmailDepartment({
                      label: "Select Department",
                      value: null,
                    });
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleEmailClientWiseTimesheetReportData?.();
                  toggleShowDropdown();
                  handleEmailReportStartDate?.("");
                  handleEmailReportEndDate?.("");
                }}
                disabled={
                  emailReportStartDate && emailReportEndDate ? false : true
                }
              >
                Email Report
              </button>
            </div>
          </div>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default EmailTimeSheetReportPopup;
